import React, { useContext } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Home from "../pages/Content/Home/Home";
import POS from "../pages/Content/POS/POS";
import Products from "../pages/Content/Products/Products";
import ProductCategories from "../pages/Content/ProductCategories/ProductCategories";
import ProductUnits from "../pages/Content/ProductUnits/ProductUnits";
import Transactions from "../pages/Content/Transactions/Transactions";
import StoreConfiguration from "../pages/Content/StoreConfiguration/StoreConfiguration";
import Branches from "../pages/Content/Branches/Branches";
import Employees from "../pages/Content/Employees/Employees";
import Helpdesk from "../pages/Content/Helpdesk/Helpdesk";
import SalesSummary from "../pages/Content/Reports/SalesSummary";
import SalesByItems from "../pages/Content/Reports/SalesByItems";
import SalesByCategories from "../pages/Content/Reports/SalesByCategories";
import RefundsByItems from "../pages/Content/Reports/RefundsByItems";
import RefundsByCategories from "../pages/Content/Reports/RefundsByCategories";
import ReportByBranches from "../pages/Content/Reports/ReportByBranches";
import Invoices from "../pages/Content/Invoices/Invoices";
import Payments from "../pages/Content/Payments/Payments";
import ExternalIntegration from "../pages/Content/ExternalIntegration/ExternalIntegration";
import ZatcaOnboarding from "../pages/Content/ZatcaOnboarding/ZatcaOnboarding";
import ViewZatcaDevice from "../pages/Content/ZatcaOnboarding/ViewZatcaDevice";
import ZatcaInvoiceIssues from "../pages/Content/ZatcaInvoices/ZatcaInvoiceIssues";
import {
  BarsOutlined,
  BarcodeOutlined,
  HomeOutlined,
  DollarOutlined,
  BarChartOutlined,
  SettingOutlined,
  ShopOutlined,
  WalletOutlined,
  EnvironmentOutlined,
  TeamOutlined,
  AccountBookOutlined,
  DesktopOutlined,
  CustomerServiceOutlined,
  PercentageOutlined,
  ApiOutlined,
  DeploymentUnitOutlined,
  ReconciliationOutlined,
  AuditOutlined,
  MoneyCollectOutlined,
  ScheduleOutlined,
  TagOutlined,
  UserOutlined,
  ShoppingOutlined,
  ColumnHeightOutlined,
  DatabaseOutlined,
  InboxOutlined,
  WarningOutlined,
  EditOutlined,
  SwapOutlined,
  LineChartOutlined,
  UnorderedListOutlined,
  FolderOutlined,
  RollbackOutlined,
  UndoOutlined,
  BranchesOutlined,
  TableOutlined,
  FundOutlined,
  CreditCardOutlined,
  SafetyCertificateOutlined,
  GlobalOutlined,
} from "@ant-design/icons";
import Subscriptions from "../pages/Content/Subscriptions/Subscriptions";
import { AppContext } from "../context/AppContextProvider";
import { filterPagesByAddons } from "../utils/utils.js";
import Discounts from "../pages/Content/Discounts/Discounts";
import RegisterConfirmed from "../pages/Auth/Register/RegisterConfirmed";
import Addons from "../pages/Content/Addons/Addons";
import AddonDetail from "../pages/Content/Addons/AddonDetail.js";
import Tables from "../pages/Content/Tables/Tables";
import Orders from "../pages/Content/Orders/Orders.js";
import EditOrder from "../pages/Content/Orders/EditOrder.js";
import ViewOrder from "../pages/Content/Orders/ViewOrder.js";
import { AddonName } from "../configs/constants.js";
import Stock from "../pages/Content/Inventory/Stock/Stock.js";
import StockAdjustment from "../pages/Content/Inventory/StockAdjustment.js";
import ViewStockAdjustment from "../pages/Content/Inventory/ViewStockAdjustment.js";
import StockTransfer from "../pages/Content/Inventory/StockTransfer.js";
import ViewTransfer from "../pages/Content/Inventory/ViewTransfer.js";
import EditTransfer from "../pages/Content/Inventory/EditTransfer.js";
import Customers from "../pages/Content/Customers/Customers.js";
import ViewCustomer from "../pages/Content/Customers/ViewCustomer.js";
import SalesInvoices from "../pages/Content/SalesInvoices/SalesInvoices.js";
import ViewSalesInvoice from "../pages/Content/SalesInvoices/ViewSalesInvoice.js";
import TaxConfiguration from "../pages/Content/TaxConfiguration/TaxConfiguration.js";
import EditDraftInvoices from "../pages/Content/SalesInvoices/EditDraftInvoices.js";
import PrintTicket from "../pages/Content/TicketManagement/PrintTicket.js";
import Ticketing from "../pages/Content/TicketManagement/Ticketing.js";
import ProductTags from "../pages/Content/ProductTags/ProductTags.js";
import LowStock from "../pages/Content/Inventory/LowStock/LowStock.js";
import CustomerDisplayScreen from "../pages/Content/DisplayScreens/CustomerDisplayScreen.js";
import KitchenDisplayScreens from "../pages/Content/DisplayScreens/KitchenDisplayScreens.js";
import WebsiteBuilder from "../pages/Content/WebsiteBuilder/WebsiteBuilder.js";

export const ContentPages = [
  {
    path: "/",
    name: "home",
    text: "home",
    component: Home,
    icon: HomeOutlined,
    showInSider: true,
    addonName: null,
  },
  {
    path: "/pos",
    name: "pos",
    text: "pos",
    component: POS,
    icon: ShopOutlined,
    showInSider: true,
    addonName: null,
  },
  {
    path: "/customers",
    name: "customers",
    text: "customers",
    component: Customers,
    icon: UserOutlined,
    showInSider: true,
    addonName: AddonName.CustomerManagement,
  },
  {
    path: "/customers/:customerId",
    name: "view_customer",
    text: "customer_details",
    icon: false,
    component: ViewCustomer,
    showInSider: false,
    addonName: AddonName.CustomerManagement,
  },
  {
    path: "/orders",
    name: "orders",
    text: "orders",
    component: Orders,
    icon: ReconciliationOutlined,
    showInSider: true,
    addonName: AddonName.OrderManagement,
  },
  {
    path: "/orders/:orderId",
    name: "view_order",
    text: "view_order",
    component: ViewOrder,
    icon: false,
    showInSider: false,
    addonName: AddonName.OrderManagement,
  },
  {
    path: "/orders/:orderId/edit",
    name: "edit_order",
    text: "edit_order",
    component: EditOrder,
    icon: false,
    showInSider: false,
    addonName: AddonName.OrderManagement,
  },
  {
    path: "/transactions",
    name: "transactions",
    text: "transactions",
    component: Transactions,
    icon: DollarOutlined,
    showInSider: true,
    addonName: null,
  },
  {
    name: "products_list",
    text: "products",
    icon: ShoppingOutlined,
    showInSider: true,
    addonName: null,
    subMenus: [
      {
        path: "/products",
        name: "products",
        text: "products_list",
        component: Products,
        icon: BarcodeOutlined,
        showInSider: true,
        addonName: null,
      },
      {
        path: "/categories",
        name: "categories",
        text: "categories",
        component: ProductCategories,
        icon: BarsOutlined,
        showInSider: true,
        addonName: null,
      },
      {
        path: "/units",
        name: "units",
        text: "units",
        component: ProductUnits,
        icon: ColumnHeightOutlined,
        showInSider: true,
        addonName: null,
      },
      {
        path: "/options",
        name: "options",
        text: "options",
        component: ProductTags,
        icon: TagOutlined,
        showInSider: true,
        addonName: null,
      },
    ],
  },
  {
    name: "inventory",
    text: "inventory",
    icon: DatabaseOutlined,
    showInSider: true,
    addonName: AddonName.Stock,
    subMenus: [
      {
        path: "/inventory/stock",
        name: "stock",
        text: "stock",
        component: Stock,
        icon: InboxOutlined,
        showInSider: true,
        addonName: AddonName.Stock,
      },
      {
        path: "/inventory/low-stock",
        name: "low-stock",
        text: "low_stock",
        component: LowStock,
        icon: WarningOutlined,
        showInSider: true,
        addonName: AddonName.Stock,
      },
      {
        path: "/inventory/stock-adjustment",
        name: "stock-adjustment",
        text: "stock_adjustment",
        component: StockAdjustment,
        icon: EditOutlined,
        showInSider: true,
        addonName: AddonName.Stock,
      },
      {
        path: "/inventory/stock-transfer",
        name: "stock-transfer",
        text: "stock_transfer",
        component: StockTransfer,
        icon: SwapOutlined,
        showInSider: true,
        addonName: AddonName.Stock,
      },
    ],
  },
  {
    path: "/inventory/stock-adjustment/:adjustmentId",
    name: "view_stock_adjustment",
    text: "view_stock_adjustment",
    icon: false,
    component: ViewStockAdjustment,
    showInSider: false,
    addonName: AddonName.Stock,
  },
  {
    path: "/inventory/stock-transfer/:transferId",
    name: "view_transfer",
    text: "view_transfer",
    icon: false,
    component: ViewTransfer,
    showInSider: false,
    addonName: AddonName.Stock,
  },
  {
    path: "/inventory/stock-transfer/:transferId/edit",
    name: "edit_transfer",
    text: "edit_transfer",
    icon: false,
    component: EditTransfer,
    showInSider: false,
    addonName: AddonName.Stock,
  },
  {
    path: "/branches",
    name: "branches",
    text: "branches",
    component: Branches,
    icon: EnvironmentOutlined,
    showInSider: true,
    addonName: null,
  },
  {
    path: "/tables",
    name: "tables",
    text: "tables",
    component: Tables,
    icon: TableOutlined,
    showInSider: true,
    addonName: AddonName.TableManagement,
  },
  {
    path: "/ticketing",
    name: "ticketing",
    text: "tickets",
    component: Ticketing,
    icon: ScheduleOutlined,
    showInSider: true,
    addonName: AddonName.Ticketing,
  },
  {
    path: "/print-ticket",
    name: "print_ticket",
    text: "print_ticket",
    component: PrintTicket,
    icon: false,
    showInSider: false,
    addonName: AddonName.Ticketing,
  },
  {
    path: "/sales-invoice",
    name: "sales_invoice",
    text: "sales_invoice",
    component: SalesInvoices,
    icon: AuditOutlined,
    showInSider: true,
    addonName: AddonName.A4SalesInvoice,
  },
  {
    path: "/sales-invoice/:salesInvoiceId",
    name: "view_sales_invoice",
    text: "view_sales_invoice",
    component: ViewSalesInvoice,
    icon: false,
    showInSider: false,
    addonName: AddonName.A4SalesInvoice,
  },
  {
    path: "/sales-invoice/:salesInvoiceId/edit",
    name: "edit_sales_invoice",
    text: "edit_sales_invoice",
    component: EditDraftInvoices,
    icon: false,
    showInSider: false,
    addonName: AddonName.A4SalesInvoice,
  },
  {
    path: "/employees",
    name: "employees",
    text: "employees",
    component: Employees,
    icon: TeamOutlined,
    showInSider: true,
    addonName: null,
  },
  {
    path: "/discounts",
    name: "discounts",
    text: "discounts",
    component: Discounts,
    icon: PercentageOutlined,
    showInSider: true,
    addonName: null,
  },
  {
    path: "/customer-display-screen",
    name: "customer_display_screen",
    text: "customer_display_screen",
    component: CustomerDisplayScreen,
    icon: DesktopOutlined,
    showInSider: true,
    addonName: AddonName.CustomerDisplaySystem,
  },
  {
    path: "/kitchen-display-screens",
    name: "kitchen_display_screens",
    text: "kitchen_display_screens",
    component: KitchenDisplayScreens,
    icon: FundOutlined,
    showInSider: true,
    addonName: AddonName.KitchenDisplaySystem,
  },
  {
    name: "reports",
    text: "reports",
    icon: BarChartOutlined,
    showInSider: true,
    addonName: null,
    subMenus: [
      {
        path: "/reports/sales-summary",
        name: "sales-summary",
        text: "sales_summary",
        component: SalesSummary,
        icon: LineChartOutlined,
        showInSider: true,
        addonName: null,
      },
      {
        path: "/reports/sales-by-items",
        name: "sales-by-items",
        text: "sales_by_items",
        component: SalesByItems,
        icon: UnorderedListOutlined,
        showInSider: true,
        addonName: null,
      },
      {
        path: "/reports/sales-by-categories",
        name: "sales-by-categories",
        text: "sales_by_categories",
        component: SalesByCategories,
        icon: FolderOutlined,
        showInSider: true,
        addonName: null,
      },
      {
        path: "/reports/refunds-by-items",
        name: "refunds-by-items",
        text: "refunds_by_items",
        component: RefundsByItems,
        icon: RollbackOutlined,
        showInSider: true,
        addonName: null,
      },
      {
        path: "/reports/refunds-by-categories",
        name: "refunds-by-categories",
        text: "refunds_by_categories",
        component: RefundsByCategories,
        icon: UndoOutlined,
        showInSider: true,
        addonName: null,
      },
      {
        path: "/reports/report-by-branch",
        name: "report-by-branch",
        text: "report_by_branch",
        component: ReportByBranches,
        icon: BranchesOutlined,
        showInSider: true,
        addonName: null,
      },
    ],
  },
  {
    path: "/helpdesk",
    name: "helpdesk",
    text: "help_desk",
    component: Helpdesk,
    icon: CustomerServiceOutlined,
    showInSider: true,
    addonName: null,
  },
  {
    path: "/subscriptions",
    name: "subscriptions",
    text: "subscriptions",
    component: Subscriptions,
    icon: WalletOutlined,
    showInSider: true,
    addonName: null,
  },
  {
    path: "/invoices",
    name: "invoices",
    text: "invoices",
    component: Invoices,
    icon: AccountBookOutlined,
    showInSider: true,
    addonName: null,
  },
  {
    path: "/addons",
    name: "addons",
    text: "addons",
    component: Addons,
    icon: DeploymentUnitOutlined,
    showInSider: true,
    addonName: null,
  },
  {
    path: "/addons/:addonId",
    name: "addon_detail",
    text: "addon_detail",
    component: AddonDetail,
    icon: false,
    showInSider: false,
    addonName: null,
  },
  {
    path: "/my-website",
    name: "website",
    text: "website",
    component: WebsiteBuilder,
    icon: GlobalOutlined,
    showInSider: true,
    addonName: AddonName.Website,
  },
  {
    path: "/external-integration",
    name: "external-integration",
    text: "external_integration",
    component: ExternalIntegration,
    icon: ApiOutlined,
    showInSider: true,
    addonName: null,
  },
  {
    path: "/store-configuration",
    name: "store-configuration",
    text: "store_configuration",
    component: StoreConfiguration,
    icon: SettingOutlined,
    showInSider: true,
    addonName: null,
  },
  {
    path: "/tax-configuration",
    name: "tax_configuration",
    text: "tax_configuration",
    component: TaxConfiguration,
    icon: MoneyCollectOutlined,
    showInSider: true,
    addonName: null,
  },
  {
    name: "zatca",
    text: "zatca",
    icon: SafetyCertificateOutlined,
    showInSider: true,
    addonName: AddonName.ZatcaEInvoicing,
    subMenus: [
      {
        path: "/zatca-onboarding",
        name: "zatca_onboarding",
        text: "zatca_onboarding",
        component: ZatcaOnboarding,
        icon: SafetyCertificateOutlined,
        showInSider: true,
        addonName: AddonName.ZatcaEInvoicing,
      },
      {
        path: "/zatca-invoice-issues",
        name: "zatca_invoice_issues",
        text: "zatca_invoice_issues",
        component: ZatcaInvoiceIssues,
        icon: WarningOutlined,
        showInSider: true,
        addonName: AddonName.ZatcaEInvoicing,
      },
    ],
  },
  {
    path: "/zatca-onboarding/:deviceId",
    name: "zatca_device_details",
    text: "zatca_device_details",
    component: ViewZatcaDevice,
    icon: false,
    showInSider: false,
    addonName: AddonName.ZatcaEInvoicing,
  },

  {
    path: "/payments",
    name: "payments",
    text: "",
    component: Payments,
    icon: CreditCardOutlined,
    showInSider: false,
    addonName: null,
  },
  {
    path: "/register-confirmed",
    name: "register-confirmed",
    text: "register_confirmed",
    component: RegisterConfirmed,
    icon: false,
    showInSider: false,
    addonName: null,
  },
];

const AppRoutes = () => {
  const { authUser } = useContext(AppContext);

  return (
    <>
      <Routes>
        <Route exact path="/home" element={<Navigate to="/" replace />} />
        <Route path="/" element={<Home />} />

        {filterPagesByAddons(ContentPages, authUser).map(function (page, i) {
          if (page.component) {
            return (
              <Route
                exact
                path={page.path}
                name={page.name}
                element={<page.component />}
                key={page.name}
              />
            );
          } else {
            let subRoutes =
              page.subMenus &&
              filterPagesByAddons(page.subMenus, authUser).map(
                function (subPage, i) {
                  if (subPage.component) {
                    return (
                      <Route
                        exact
                        path={subPage.path}
                        name={subPage.name}
                        element={<subPage.component />}
                        key={subPage.name}
                      />
                    );
                  }
                  return false;
                },
              );
            return subRoutes;
          }
        })}
      </Routes>
    </>
  );
};

export default AppRoutes;
